import React from 'react';

class UtilHighlightStr extends React.Component {

   /*****************************************/
   /* FUNCTION */
   /*****************************************/

   /*****************************************/
   /* HANDLE */
   /*****************************************/

   /*****************************************/
   /* EVENT */
   /*****************************************/

   /*****************************************/
   /* RENDER */
   /*****************************************/
   render() {
      const str = this.props.str
      const filterText = this.props.filterText

      const strReg = "(" + filterText + ")"
      const reg = new RegExp(strReg, "i")
      const newStr = str.replace(reg, '<span class="highlight">$1</span>')
      return (
         <span dangerouslySetInnerHTML={{__html: newStr}} />
      )
   }
}

export default UtilHighlightStr;



// WEBPACK FOOTER //
// ./src/UtilHighlightStr.js